import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminRoutingModule } from './admin-routing.module';
import { AdminComponent } from './admin.component';
import { DashboardAdminComponent } from './dashboard-admin/dashboard-admin.component';
import { HomeModule } from '../home/home.module';
import { HeaderAdminComponent } from './header-admin/header-admin.component';
import { MenuAdminComponent } from './menu-admin/menu-admin.component';
import { ToursAdminComponent } from './tours-admin/tours-admin.component';
import { PacksAdminComponent } from './packs-admin/packs-admin.component';
import { AgenciasAdminComponent } from './agencias-admin/agencias-admin.component';
import { PasajerosAdminComponent } from './pasajeros-admin/pasajeros-admin.component';
import { ModalMsgComponent } from './modal-msg/modal-msg.component';
import { AgenciasPendientesComponent } from './agencias-pendientes/agencias-pendientes.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxCurrencyModule } from "ngx-currency";
import { AgenciaDetalleComponent } from './agencia-detalle/agencia-detalle.component';
import { ToursCreateComponent } from './tours-create/tours-create.component';
import { MinibusComponent } from './minibus/minibus.component';
import { CocheMixComponent } from './coche-mix/coche-mix.component';
import { BusSemicamaComponent } from './bus-semicama/bus-semicama.component';
import { TourItinerarioComponent } from './tour-itinerario/tour-itinerario.component';
import { TourAgenciasReservadosComponent } from './tour-agencias-reservados/tour-agencias-reservados.component';
import { TourAgenciasConfirmadasComponent } from './tour-agencias-confirmadas/tour-agencias-confirmadas.component';
import { TourExcursionesComponent } from './tour-excursiones/tour-excursiones.component';
import { ModalCategoriaHotelComponent } from './modal-categoria-hotel/modal-categoria-hotel.component';
import { TourUpdateComponent } from './tour-update/tour-update.component';
import { ModalPasajeroConfirmadoComponent } from './modal-pasajero-confirmado/modal-pasajero-confirmado.component';
import { ModalPasajeroEliminadoComponent } from './modal-pasajero-eliminado/modal-pasajero-eliminado.component';
import { ModalPasajerosDetallesComponent } from './modal-pasajeros-detalles/modal-pasajeros-detalles.component';
import { PasajeroReservadoComponent } from './pasajero-reservado/pasajero-reservado.component';
import { TourAgenciasConfirmadasDetalleComponent } from './tour-agencias-confirmadas-detalle/tour-agencias-confirmadas-detalle.component';
import { ToursConfirmadosComponent } from './tours-confirmados/tours-confirmados.component';
import { PasajeroConfirmadoComponent } from './pasajero-confirmado/pasajero-confirmado.component';
import { TourAgenciasComponent } from './tour-agencias/tour-agencias.component';
import { ModalConfirmComponent } from './modal-confirm/modal-confirm.component';
import { ModalAsientosComponent } from './modal-asientos/modal-asientos.component';
import { ModalConfirmPasajeroDeleteComponent } from './modal-confirm-pasajero-delete/modal-confirm-pasajero-delete.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { JwPaginationModule } from '../jw-pagination/jw-pagination.module';

@NgModule({
  declarations: [
    AdminComponent,
    DashboardAdminComponent,
    HeaderAdminComponent,
    MenuAdminComponent,
    ToursAdminComponent,
    PacksAdminComponent,
    AgenciasAdminComponent, ModalMsgComponent, AgenciasPendientesComponent,
    PasajerosAdminComponent, ModalPasajerosDetallesComponent,
    AgenciaDetalleComponent, ToursCreateComponent, MinibusComponent,
    CocheMixComponent, BusSemicamaComponent, TourItinerarioComponent,
    TourAgenciasConfirmadasComponent,
    TourExcursionesComponent, ModalCategoriaHotelComponent, TourUpdateComponent,
    TourAgenciasReservadosComponent, TourAgenciasConfirmadasComponent, ModalPasajeroConfirmadoComponent, ModalPasajeroEliminadoComponent,
    PasajeroReservadoComponent, TourAgenciasConfirmadasDetalleComponent,
    ToursConfirmadosComponent, PasajeroConfirmadoComponent, TourAgenciasComponent, ModalConfirmComponent, ModalAsientosComponent, ModalConfirmPasajeroDeleteComponent
  ],
  exports: [
    ModalMsgComponent,
    MinibusComponent,
    BusSemicamaComponent,
    CocheMixComponent,
    ModalMsgComponent,
    ModalPasajeroConfirmadoComponent,
    ModalPasajeroEliminadoComponent
  ],
  imports: [
    CommonModule,
    AdminRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    NgxCurrencyModule,
    HomeModule,
    LoadingBarHttpClientModule,
    // for Router use:
    LoadingBarRouterModule,
    // for Core use:
    LoadingBarModule,
    // pagination:
    JwPaginationModule
  ]
})
export class AdminModule { }
